import { render, staticRenderFns } from "./businessList.vue?vue&type=template&id=6eda796c"
import script from "./businessList.vue?vue&type=script&lang=js"
export * from "./businessList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports